import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import store from './redux/store';
import reportWebVitals from './reportWebVitals';
import {AuthContextProvider} from './store/AuthContext';
import { Provider } from 'react-redux';
import AdminTheme from './theme/AdminTheme';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
  <React.StrictMode>
    <AdminTheme>
    <AuthContextProvider>
      <Provider store={store}>
       <App />
       </Provider>
    </AuthContextProvider>
    </AdminTheme>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
